import React, { useRef } from 'react';

import Button from '../Button';
import Menu from '../Menu';
import './_menu-button.scss';

const ALLOWED_ALIGN = ['start', 'end'];














function MenuButton({
  children,
  buttonProps,
  align,
  id,
  fallbackPlacements,
  customButton,
  isCompact,
  className,
  closeAfterClick,
  toggleCompactMenu = () => {}
}) {
  const btnId = `${id}-btn`;
  const menuId = `${id}-menu`;
  const menuAlign = ALLOWED_ALIGN.includes(align) ? align : 'end';

  const menuRef = useRef(null);

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.toggleMenu();
    }
  };

  return (
    <div id={id} className="menu-button">
      {customButton ?
      <div id={btnId}>
          {React.cloneElement(customButton, {
          onClick: toggleMenu,
          id: btnId
        })}
        </div> :

      <Button
        {...buttonProps}
        id={btnId}
        type="TERTIARY"
        hasMenuIcon={!isCompact}
        onClick={toggleMenu}>

          {isCompact ? null : buttonProps?.children}
        </Button>}

      <Menu
        id={menuId}
        align={menuAlign || 'start'}
        className={className}
        buttonId={btnId}
        ref={menuRef}
        fallbackPlacements={fallbackPlacements}
        closeAfterClick={closeAfterClick}
        toggleCompactMenu={toggleCompactMenu}>

        {children}
      </Menu>
    </div>);

}

export default MenuButton;